
export enum StockStatus {
  HEALTHY = 'Healthy',
  CRITICAL = 'Critical',
  WARNING = 'Warning'
}

export interface InventoryItem {
  id: string;
  itemNumber: string;
  itemName: string;
  supplier: string;
  currentStock: number;
  minStock: number;
  status: StockStatus;
  category: string;
  lastUpdated: string;
}

export enum ChannelType {
  EMAIL = 'eMail',
  EDI = 'EDI',
  EBILL = 'eBill',
  PRINT = 'Print',
  EPOST = 'ePost'
}

// Re-export legacy types if needed for UI components compatibility, or just clean up
export type Period = '1h' | '4h' | 'Day' | 'Week' | 'Month' | 'Year';